(function () {
  'use strict';

  angular
    .module('vcdms.vcfile')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcdmsfile', {
        url: '/vcdmsfile',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;filesearch file="" fileref="" editinplace="true"&gt;</tt></h3><div ui-view="filesearchview"></div>
              <h3 class="alert alert-info"><tt>&lt;filesearch file="" fileref="" parentsave=""&gt;</tt></h3><div ui-view="filesearchview2"></div>
              <h3 class="alert alert-info"><tt>&lt;fileeditor file="" mode="" onClose=""&gt;</tt></h3><div ui-view="fileeditview"></div>
              <h3 class="alert alert-info"><tt>&lt;fileupload label="@?" color="@?" clientid="&lt;?" consultid="&lt;?" examid="&lt;?"&gt;</tt></h3><div ui-view="filenewview"></div>
              <h3 class="alert alert-info"><tt>&lt;imagecapture label="@?" color="@?" clientid="&lt;?" consultid="&lt;?" examid="&lt;?"&gt;</tt></h3><div ui-view="filenewview2"></div>
              <h3 class="alert alert-info"><tt>&lt;filelist files="?"&gt;</tt></h3><div ui-view="filelistview"></div>
              <h3 class="alert alert-info"><tt>&lt;consultfilelist consultid=""&gt;</tt></h3><div ui-view="consultfilelistview"></div>
              <h3 class="alert alert-info"><tt>&lt;complexfilelist files="?"&gt;</tt></h3><div ui-view="complexfilelistview"></div>
            `
          }
        },
        onEnter: function () {
          $log.debug('debug/routes - playground.vcdmsvcfile entered');
        }
      });
    
    
    $stateProvider
      .state('playground.vcdmsfile.allcomponents', {
        url: '/allcomponents',
        resolve: {
          file: function () {
            return '';
          },
          fileref: function () {
            return '';
          },
          someconsultid: function () {
            return '586e2b49a60359af68ae5cb9';
          },
          somefile: function (File) {
            return File.$find('572b31b07c01597e3e150923');
          },
          allfiles: function (File) {
            return File.$search({active: true});
          },
          pscans: function (File) {
            return File.$search({jobid: 'processedscan', active: {$ne: false}});
          },
          scans: function (File) {
            return File.$search({jobid: 'scan', active: {$ne: false}});
          },
          parentsavesearch: function () {
            return function (file, fileref) {
              console.log('debug: dummy parentsave called for filesearch with: ', file, fileref);
            };
          },
          eip: function () {
            return true;
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve
          'filesearchview@playground.vcdmsfile': {
            component: 'filesearch',
            bindings: {
              file: 'file',
              fileref: 'fileref',
              editinplace: 'eip'
            }
          },
          'filesearchview2@playground.vcdmsfile': {
            component: 'filesearch',
            bindings: {
              file: 'file',
              fileref: 'fileref',
              parentsave: 'parentsavesearch'
            }
          },
          'fileeditview@playground.vcdmsfile': {
            component: 'fileeditor',
            bindings: {
              file: 'somefile'
            }
          },
          'filenewview@playground.vcdmsfile': {
            component: 'fileupload',
            bindings: {
              consultid: 'someconsultid'
            }
          },
          'filenewview2@playground.vcdmsfile': {
            component: 'imagecapture',
            bindings: {
              consultid: 'someconsultid'
            }
          },
          'filelistview@playground.vcdmsfile': {
            component: 'filelist',
            bindings: {
              files: 'allfiles'
            }
          },
          'consultfilelistview@playground.vcdmsfile': {
            component: 'consultfilelist',
            bindings: {
              consultid: 'someconsultid'
            }
          },
          'complexfilelistview@playground.vcdmsfile': {
            component: 'complexfilelist',
            bindings: {
              files: 'pscans'
            }
          }
        },
        onEnter: function () {
          console.log('playground.vcdmsfile.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());
